module.exports = __webpack_public_path__ + "static/media/JS Logo 2.a7805e9a.png";